export default __webpack_public_path__ + "img/productive.62994714.png";